import Box from '@mui/material/Box';
import { useTheme } from '@mui/material/styles';
import logo from '@/images/inventra_logo.png';
import favicon from '@/images/fav.png';

interface BrandMarkProps {
  /** On the collapsed rail there's no room for the full wordmark — swap to the square favicon
   * mark instead of squeezing the wide logo down to an unreadable sliver. */
  collapsed?: boolean;
}

export default function BrandMark({ collapsed }: BrandMarkProps) {
  const theme = useTheme();

  return (
    <Box
      sx={{
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        // The logo's navy wordmark reads fine on the light sidebar, but disappears against the
        // dark-mode sidebar's near-black background — give it a white backing plate in dark mode
        // only so it stays legible either way.
        bgcolor: theme.palette.mode === 'dark' ? '#fff' : 'transparent',
        borderRadius: theme.palette.mode === 'dark' ? 1 : 0,
        p: theme.palette.mode === 'dark' ? 1 : 0,
      }}
    >
      <Box
        component="img"
        src={collapsed ? favicon : logo}
        alt="Inventra"
        sx={{
          // Fills the sidebar's width (its container already accounts for the toolbar's own
          // padding) when expanded — height follows the image's own aspect ratio. Collapsed uses
          // the square favicon mark at a fixed small size instead of stretching to the rail width.
          width: collapsed ? 32 : '100%',
          height: 'auto',
          display: 'block',
        }}
      />
    </Box>
  );
}
